import React from 'react';
import { CheckCircleOutlined } from '@ant-design/icons';

import '../_styles/AxssComponents.css'

class IconGhostBtn extends React.Component {
    render(){
        const {
            icon: IconComponent = CheckCircleOutlined,
            btnIconColor = 'black',
            btnSize = '16px',
            btnTitle,
            onClick,
        } = this.props;

        return(
            <IconComponent
                className="axss-custom-tag"
                style={{ color: btnIconColor, fontSize: btnSize}}
                title={btnTitle}
                onClick={onClick} 
            />
        )
    }
}
export default IconGhostBtn;